import { uuid } from '../utilities/string';

export default class Document {
    constructor(file, role, docType, displayName = undefined, permissions = undefined) {
        this.content_type = file.type;
        this.doc_type = docType;
        this.display_name = displayName;
        this.name = `${docType}_${role.id}`;
        this.filename = `${uuid()}/${file.name}`;
        this.ref_id = role.id;
        this.ref_type = role.type;
        this.permissions = permissions;
    }
}



// WEBPACK FOOTER //
// ./src/models/document.jsx